import React from "react";
import { Link } from "react-router-dom";
import { Routes_path } from "../../routerApp";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Header from "./Header";

const logoScarso = require("../../../../static/images/logo/logo-Scarso-Nuovo.png");

export default function TopBar() {
	return (
		<AppBar
			position="sticky"
			elevation={0}
			sx={{
				background: "linear-gradient(60deg, #ffffff, #ffd42d22)",
				borderBottom: "1px solid rgba(0,0,0,0.06)",
			}}
		>
			<Toolbar sx={{ gap: 2 }}>
				<Link to={Routes_path.HOME} style={{ display: "flex" }}>
					<img
						src={logoScarso}
						alt="Scarso Romualdo e Figli"
						style={{ width: 180 }}
					/>
				</Link>
				<Typography
					variant="h6"
					sx={{
						color: "#333",
						display: { xs: "none", md: "block" },
						letterSpacing: "0.04em",
					}}
				>
					Macellazione Avicola
				</Typography>
				<Box sx={{ flexGrow: 1 }} />
				<Header />
			</Toolbar>
		</AppBar>
	);
}
